// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--QeXhl","icon":"_02712f2b3b--icon--pZ9yb","heading":"_02712f2b3b--heading--j6coO"};